import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);


export default class StaggeredOpacity extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      element:[]
    };
  }

  mount() {
    let that = this;
    gsap.to(that.ref.element, {opacity: 1, duration: 0.23, stagger: 0.05, scrollTrigger:{
      trigger: that.ref.element,
      start: 'top center',
      }})
  }


}